import { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

// User's WhatsApp number (placeholder — update with real number)
// Format: international, digits only, no + or spaces
const WHATSAPP_NUMBER = '358503443237';

const WhatsAppFloat = () => {
  const [open, setOpen] = useState(false);
  const { language } = useLanguage();

  const copy = {
    en: {
      title: 'Talk to us on WhatsApp',
      subtitle: 'We usually reply within a few business hours.',
      defaultMsg: "Hi 2DS — I'd like to talk about landing my company in Finland.",
      send: 'Open WhatsApp chat',
      hint: 'Direct line to our founding team in Espoo.',
    },
    fi: {
      title: 'Keskustele kanssamme WhatsAppissa',
      subtitle: 'Vastaamme yleensä muutaman tunnin sisällä arkisin.',
      defaultMsg: 'Hei 2DS — haluaisin keskustella yritykseni laskeutumisesta Suomeen.',
      send: 'Avaa WhatsApp-keskustelu',
      hint: 'Suora yhteys perustajatiimiimme Espoossa.',
    },
  };
  const c = copy[language] || copy.en;
  const waUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(c.defaultMsg)}`;

  return (
    <>
      {/* Floating button */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Open WhatsApp"
        data-testid="whatsapp-float-toggle"
        className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform"
      >
        {open ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
      </button>

      {/* Mini panel */}
      {open && (
        <div
          className="fixed bottom-24 right-6 z-40 w-80 max-w-[calc(100vw-3rem)] bg-white border border-warm rounded-2xl shadow-2xl overflow-hidden"
          data-testid="whatsapp-float-panel"
        >
          <div className="bg-[#075E54] text-white px-4 py-3 flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-white/15 flex items-center justify-center">
              <MessageCircle className="w-4 h-4" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold">{c.title}</p>
              <p className="text-xs opacity-80">{c.subtitle}</p>
            </div>
          </div>
          <div className="p-4 bg-cream/60">
            <p className="text-sm text-ink-light leading-relaxed mb-3 italic">"{c.defaultMsg}"</p>
            <p className="text-xs text-ink-muted mb-4">{c.hint}</p>
            <a
              href={waUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-open-chat"
              className="flex items-center justify-center gap-2 w-full bg-[#25D366] text-white py-2.5 rounded-full text-sm font-medium hover:bg-[#1ebd5b] transition-colors"
            >
              <Send className="w-4 h-4" />
              {c.send}
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppFloat;
